import { useState } from 'react';
import { Box, styled, Tabs, tabsClasses } from '@mui/material';
import { LwTab, ModalPanelTabType } from 'redesign';
import { CompanyDetailAndJobGroups } from '@types';
import { useTranslation } from 'react-i18next';
import { getSettingsDetailTabs } from './get-settings-tabs';

type SettingsDetailThemeProps = {
  companyData: CompanyDetailAndJobGroups;
};

export const SettingsDetailTabs = ({ companyData }: SettingsDetailThemeProps) => {
  const { t } = useTranslation(['web-common', 'ogp-screen-specific']);

  const tabs: ModalPanelTabType[] = getSettingsDetailTabs(companyData, t);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  return (
    <Box>
      <Box mb={4}>
        <StyledTabs
          value={selectedTab.id}
          onChange={(_, tabId) => {
            const selectedTab = tabs.find((i) => i.id === tabId) ?? tabs[0];
            setSelectedTab(selectedTab);
          }}
          aria-label="settings-detail-tabs"
        >
          {tabs.map((tab) => (
            <LwTab key={tab.id} value={tab.id} label={tab.tabLabel} />
          ))}
        </StyledTabs>
      </Box>
      <Box>{selectedTab.element}</Box>
    </Box>
  );
};

const StyledTabs = styled(Tabs)(({ theme }) => ({
  [`& div.${tabsClasses.scroller}`]: {
    [`& .${tabsClasses.flexContainer}`]: {
      gap: theme.spacing(2),
      overflow: 'visible',
    },
  },
}));
